module.exports = __webpack_public_path__ + "static/assets/68cc97334ea351897a6101e428da28ac.svg";